// src/components/StatsCounter.js
import React from 'react';
import CountUp from 'react-countup';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion'; // <-- دي بتعرفنا العنصر ظاهر على الشاشة ولا لأ
import { useRef } from 'react';

// ده الـ CSS (ممكن تضيفه في ملف App.css)
/*
.stats-container {
  display: flex;
  justify-content: space-around;
  background-color: #f4f4f4;
  padding: 40px 20px;
  border-radius: 8px;
  margin: 30px 0;
}
.stat-item {
  text-align: center;
}
.stat-value {
  font-size: 2.5rem;
  font-weight: bold;
  color: #0056b3; // لون براند المكتب
}
.stat-label {
  font-size: 1rem;
  color: #333;
}
*/

function StatsCounter({ stats }) {
  const ref = useRef(null);
  // 1. بتراقب العنصر ده، وأول ما يظهر على الشاشة (once: true) هتخلي inView بـ true
  const isInView = useInView(ref, { once: true });

  return (
    // 2. بنربط الـ ref بالـ div الرئيسي
    <div ref={ref} className="stats-container">
      {stats.map((stat) => (
        <div key={stat.id} className="stat-item">
          <div className="stat-value">
            {/* 3. الـ CountUp مش هيبدأ غير لما isInView تبقى true */}
            {isInView && (
              <CountUp 
                start={0} 
                end={stat.value} 
                duration={2.5} 
                suffix={stat.suffix} 
              />
            )}
          </div>
          <div className="stat-label">{stat.label}</div>
        </div>
      ))}
    </div>
  );
}

export default StatsCounter;